import type { FC, PropsWithChildren } from "react";

import classNames from "classnames";

import styles from "./ImageNavLinksList.module.scss";

type ImageNavLinksListProps = {
  variant?: "promo-vertical" | "promo-horizontal" | "default";
};

export const ImageNavLinksList: FC<PropsWithChildren<ImageNavLinksListProps>> = ({ children, variant = "default" }) => {
  return <div className={classNames(styles.list, styles[variant])}>{children}</div>;
};
